import tw from 'twin.macro';
import { CounterChip, ScoreChip, TimerChip } from '../exercise-readout-chips';

// Portrait-mobile readout strip, per the "In performance - Camera Enabled"
// frames (Figma 1527:25757 / 25781 / 25807). Desktop floats these values as
// overlay pills on the camera; the mobile design gives them their own band
// between the camera feed and the reference video.
//
// It's a real layout row, not an overlay: its height comes out of the
// reference video below it, never out of the camera feed.
//
// The pills themselves live in exercise-readout-chips — landscape reuses them as
// corner overlays, so the two layouts cannot drift apart. What stays here is the
// band and the frame's fixed pill widths:
//   band   #F5F5F5, 20px padding, 8px gap, left-aligned
const barStyle = tw`flex w-full shrink-0 items-start gap-2 bg-[#F5F5F5] p-5`;

// Camera-disabled ("Get Ready screen - Camera disabled", Figma 864-15691 /
// 883-4798): there's no camera cell for the band to sit under, so a filled
// #F5F5F5 row would just be an empty gray strip floating at the very top of
// the screen — right where the fixed camera-warning/menu icons sit, since the
// collapsed (offscreen) camera cell no longer pushes it down. The chips
// instead float bare and stack vertically, same as the desktop overlay.
const overlayStyle = tw`flex flex-col w-full shrink-0 items-start gap-3 p-5`;

const MobileExerciseStatBar = ({
  showCounter,
  counter,
  totalReps,
  isHoldMode = false,
  showQuality,
  score,
  hasScore = true,
  showTimer,
  timerValue,
  isCameraCellVisible = true,
}) => {
  if (!showCounter && !showQuality && !showTimer) {
    return null;
  }

  return (
    // dir="ltr": align-items/flex-direction are writing-mode relative, so
    // without this, `items-start` on the (full-width, flex-col) offline
    // overlay pins to the right edge under Arabic instead of the left, and
    // the band's row order reverses too. This strip is a fixed-position video
    // control (like a player's own overlay chips), not reading-direction
    // content, so it must stay physically put regardless of language.
    <div dir="ltr" css={isCameraCellVisible ? barStyle : overlayStyle}>
      {/* 128px fixed, icon and value pushed apart (frame 25757). */}
      {showCounter && (
        <CounterChip
          counter={counter}
          totalReps={totalReps}
          isHoldMode={isHoldMode}
          chipStyle={tw`w-[128px] justify-between`}
        />
      )}

      {showQuality && (
        <ScoreChip
          score={score}
          hasScore={hasScore}
          chipStyle={tw`w-[120px] justify-center gap-2 pl-2 pr-3`}
        />
      )}

      {showTimer && <TimerChip value={timerValue} />}
    </div>
  );
};

export default MobileExerciseStatBar;
